<template>
  <div>
    <el-dialog
      title="创建自定义细分受众"
      :visible="createAudienceDialogVisible"
      width="800px"
      append-to-body
      :close-on-click-modal="false"
      @close="close"
      @opened="openInit"
    >
      <el-form
        :model="form"
        label-width="200px"
        label-suffix="："
        :rules="rules"
        ref="form"
      >
        <el-form-item
          label="自定义细分受众名称"
          prop="title"
        >
          <el-input
            v-model="form.title"
            placeholder="受众名称"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="有兴趣或行为的用户"
          prop="keywords"
        >
          <el-radio-group v-model="form.type">
            <el-radio
              :label="item.key"
              v-for="item in userTypeOptions"
              :key="item.key"
              >{{ item.name }}</el-radio
            >
          </el-radio-group>
          <div>
            <el-tooltip
              v-for="(tag, index) in keywordTags"
              :key="index"
              :content="tag.keyword"
              :disabled="tag.keyword.length <= 30"
              placement="top"
            >
              <el-tag
                closable
                @close="deleteKeywordTags(index)"
                class="m-1 tag-truncate"
                :type="tag.isUnavailable ? 'warning' : 'primary'"
              >
                {{ tag.keyword }}
              </el-tag>
            </el-tooltip>
          </div>
          <el-input
            v-model="form.keywords"
            placeholder="添加兴趣或购买意向,多个用英文逗号分隔,回车即可添加"
            :disabled="keywordCheckLoading"
            @keyup.enter.native="addKeywordAll"
          ></el-input>
          <div
            class="p-2 border border-yellow-200 rounded-lg bg-yellow-100 mt-2"
            v-if="unavailableKeywords.length > 0"
          >
            <div class="flex items-start">
              <i class="el-icon-warning text-yellow-500 text-lg mr-3 mt-0.5"></i>
              <div class="text-sm text-gray-700 leading-relaxed">
                此关键字未纳入细分受众群分析的估算范围内：{{ unavailableKeywords.join('、') }}。
                <a
                  @click="removeUnavailableKeywords"
                  href="#"
                  class="text-blue-600 underline hover:text-blue-800 ml-1"
                  >全部移除</a
                >
              </div>
            </div>
          </div>
        </el-form-item>
        <el-form-item
          label="浏览特定网站的用户"
          prop="domain"
        >
          <div>
            <el-tooltip
              v-for="(tag, index) in domainTags"
              :key="index"
              :content="tag"
              :disabled="tag.length <= 30"
              placement="top"
            >
              <el-tag
                closable
                @close="deleteTags(index)"
                class="m-1 tag-truncate"
              >
                {{ tag }}
              </el-tag>
            </el-tooltip>
          </div>
          <el-input
            v-model="form.domain"
            placeholder="添加网址多个用英文逗号分隔,回车即可添加"
            :disabled="domainCheckLoading"
            @keyup.enter.native="addDomainAll"
          ></el-input>
        </el-form-item>
        <!--  <el-form-item label="使用特定应用的用户">
          <el-input
            v-model="form.name"
            placeholder="添加应用/在Google play谷歌商店中搜索要添加的应用"
          ></el-input>
        </el-form-item> -->
      </el-form>
      <div slot="footer">
        <el-button @click="close">取 消</el-button>
        <el-button
          type="primary"
          @click="sure"
          :disabled="keywordCheckLoading || domainCheckLoading"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { createCustomerAudience, checkUrl, unavailableKeywords } from '@/api/google/create';
const userTypeOptions = [
  { key: 'PURCHASE_INTENT', name: '具有任何此类兴趣或购买意向的用户' },
  { key: 'SEARCH', name: '曾在Google上搜索任意这些字词的用户' },
];
export default {
  props: {
    createAudienceDialogVisible: {
      type: Boolean,
      default: false,
    },
    currentAccount: {
      type: Object,
      default: () => {},
    },
    editCustomAudienceItem: {
      type: Object,
      default: () => ({}),
    },
    audienceData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      form: {
        title: '',
        type: 'PURCHASE_INTENT',
        keywords: '',
        domain: '',
      },
      userTypeOptions,
      domainTags: [],
      keywordTags: [],
      unavailableKeywords: [],
      keywordCheckLoading: false,

      rules: {
        title: [{ required: true, message: '受众名称必填' }],
        keywords: [
          {
            validator: (rule, value, callback) => {
              if (this.keywordTags.length === 0 && this.domainTags.length === 0) {
                callback(new Error('兴趣词和网址至少填写一项'));
              } else {
                callback();
              }
            },
          },
        ],
        domain: [
          {
            validator: (rule, value, callback) => {
              if (this.domainTags.length === 0 && this.keywordTags.length === 0) {
                callback(new Error('兴趣词和网址至少填写一项'));
              } else {
                callback();
              }
            },
          },
        ],
      },
      domainCheckLoading: false,
    };
  },
  methods: {
    close() {
      this.$emit('update:createAudienceDialogVisible', false);
    },
    openInit() {
      this.$nextTick(() => {
        this.$refs.form.resetFields();
        if (this.editCustomAudienceItem?.resourceName) {
          this.form = { ...this.editCustomAudienceItem };
          this.domainTags = this.editCustomAudienceItem.urls;
          this.keywordTags = this.editCustomAudienceItem.keywords.map((keyword) => ({ keyword, isUnavailable: false }));
        } else {
          this.domainTags = [];
          this.keywordTags = [];
          this.form.domain = '';
          this.form.keywords = '';
        }
        this.unavailableKeywords = [];
      });
    },
    // 输入框回车事件
    addDomainAll() {
      const domainList = this.form.domain
        .split(',')
        .map((d) => d.trim())
        .filter((d) => d);
      const invalidDomains = [];

      domainList.forEach((domain) => {
        if (this.addDomainTag(domain)) {
          // 域名添加成功，无需处理
        } else {
          invalidDomains.push(domain);
        }
      });

      // 将不符合规则的域名保留在输入框中
      this.form.domain = invalidDomains.join(', ');
    },
    addDomainTag(domain) {
      const domainRegex = /^(?:https?:\/\/)?(?:www\.)?([a-zA-Z0-9-]+\.){1,}[a-zA-Z]{2,}(?:\/[^\s]*)?$/;

      if (!domainRegex.test(domain)) {
        return false;
      }

      // 去除 http:// 或 https:// 前缀
      let cleanDomain = domain.replace(/^https?:\/\//, '');
      // 去除末尾的 /
      cleanDomain = cleanDomain.replace(/\/+$/, '');

      // 去重检查
      if (this.domainTags.includes(cleanDomain)) {
        return false;
      }

      this.domainTags.push(cleanDomain);
      return true;
    },
    deleteTags(index) {
      this.domainTags.splice(index, 1);
    },
    // 添加关键词
    async addKeywordAll() {
      const keywordList = this.form.keywords
        .split(',')
        .map((k) => k.trim())
        .filter((k) => k);

      if (keywordList.length === 0) return;

      this.keywordCheckLoading = true;
      console.log(this.audienceData);
      try {
        const res = await unavailableKeywords({
          accountId: this.currentAccount.id,
          keywordList: keywordList,
          languageId: this.audienceData.target.languages[0],
          locationId: this.audienceData.target.locations.map((v) => v.criteria_id)[0],
        });

        if (res.code === 0) {
          const unavailableList = res.data || [];

          keywordList.forEach((keyword) => {
            if (!this.keywordTags.some((tag) => tag.keyword === keyword)) {
              const isUnavailable = unavailableList.includes(keyword);
              this.keywordTags.push({ keyword, isUnavailable });
            }
          });

          this.updateUnavailableKeywords();
        }
      } catch (error) {
        console.error('检查关键词失败:', error);
      } finally {
        this.keywordCheckLoading = false;
        this.form.keywords = '';
      }
    },
    // 删除关键词标签
    deleteKeywordTags(index) {
      this.keywordTags.splice(index, 1);
      this.updateUnavailableKeywords();
    },
    // 更新不可用关键词列表
    updateUnavailableKeywords() {
      this.unavailableKeywords = this.keywordTags.filter((tag) => tag.isUnavailable).map((tag) => tag.keyword);
    },
    // 移除所有不可用关键词
    removeUnavailableKeywords() {
      this.keywordTags = this.keywordTags.filter((tag) => !tag.isUnavailable);
      this.unavailableKeywords = [];
    },
    sure() {
      this.$refs.form.validate((validator) => {
        if (validator) {
          let params = {
            accountId: this.currentAccount.id,
            ...this.form,
            keywords: this.keywordTags.map((tag) => tag.keyword),
            urls: this.domainTags,
          };
          this.$showLoading();
          createCustomerAudience(params).then((res) => {
            this.$hideLoading();
            if (res.code == 0) {
              this.$emit('update:createAudienceDialogVisible', false);
              this.$emit('getList');
            }
          });
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.tag-truncate {
  max-width: 20rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
  vertical-align: middle;
  position: relative;
  padding-right: 20px;
}
:deep .el-tag .el-icon-close {
  position: absolute;
  top: 7px;
  right: 0;
}

.unavailable-tip {
  margin-top: 8px;
  font-size: 12px;
  color: #e6a23c;

  .el-button--text {
    color: #409eff;
    padding: 0;
    margin-left: 8px;
  }
}
</style>
